import React from 'react'
import { connect } from 'react-redux'
import { Link} from "react-router-dom"
import './headerM.css'
import axios from 'axios'
import { withRouter } from 'react-router-dom'

import {userList} from '../../redux/chatuser.redux.js'
import {getInFoFn} from '../../redux/chatuser.redux.js'
function jsonp(url, params, callback) {
  // 将参数序列化为查询字符串
  let queryString = Object.keys(params).map(key => {
    return `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`;
  }).join('&');

  // 如果URL中已经包含查询字符串，则添加一个'&'来连接
  if (url.indexOf('?') !== -1) {
    queryString = '&' + queryString;
  } else {
    queryString = '?' + queryString;
  }

  // 完整的请求URL
  const fullUrl = url + queryString;

  // 创建一个唯一的回调函数名
  const callbackName = `callback${Math.random().toString(36).substr(2, 9)}`;

  // 定义回调函数
  window[callbackName] = function(data) {
    if (callback) {
      callback(data);
    }
    // 移除script标签
    document.body.removeChild(script);
    // 删除window上的回调函数，避免重复调用
    delete window[callbackName];
  };

  // 创建script标签
  const script = document.createElement('script');
  script.src = fullUrl + '&callback=' + callbackName;
  script.async = true;

  // 将script标签添加到文档中
  document.body.appendChild(script);
}
/*
// 使用示例
jsonp('http://example.com/api/data', {param1: 'value1', param2: 'value2'}, function(data) {
  console.log('JSONP Response:', data);
});*/
@withRouter
@connect(
  state=>state.chatuser,
  {userList,getInFoFn}
) 



class HeaderM extends React.Component{
	constructor(props){
		super(props)
		this.state={
			
    	}
    	
	}
	componentDidMount(){
  		document.getElementById('meta1').setAttribute('content','心享俱乐部回归特权，游戏回归特权，回归特权礼包') 
  		document.getElementById('meta2').setAttribute('content','心享俱乐部全新推出游戏回归特权，心享俱乐部会员通过账号鉴定即可激活回归特权，独享特权包括回归礼包、高额返利、新游试玩等在内的游戏回归特权。') 
  	}


  
  	handleLogin(){		
		const pathname = this.props.location.pathname
		let pathtemp = pathname.split('/');
		pathtemp = pathtemp[pathtemp.length - 1];
		let loginurl = '/fapi/' + (pathtemp == 89 ? 'getLoginDNURL' : 'getLoginURL') + '?redirect_url=' + encodeURIComponent(encodeURIComponent(window.location.href));
		
		jsonp(loginurl, {}, function(data) {

			window.location.href = data.redirect_url
		 
		})
/*
		axios.jsonp(loginurl, {})
		 	.then(res=>{
		 		console.log(res)
		 	})
		
		this,axios.get(loginurl)
	      .then(res=>{
	       	if(res.data.return_code==0){
	       		console.log( res.data.redirect_url)
	       		return
	       		window.location.href = res.data.redirect_url
	 
	       	}
					     
		 })		
			*/
	}
	handleLogout(){		
		const MyOrigin = window.location.origin
		this.pathname = MyOrigin +''+ this.props.location.pathname
		
		window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(this.pathname)
	}
  	render(){
  		
  		return (

			<div className="header-m">
				<span className="logo-m"></span>
				{
					this.props.userlist.code===-1?<div className="login-m">
						<button onClick={()=>this.handleLogin()}></button>
					</div>:null
				
				}
				{
					this.props.userlist.displayAccount&&<div className="login-enter-m">
						<span>{this.props.userlist.displayAccount}</span>
						<button onClick={()=>this.handleLogout()}>注销</button>

					</div>

					
				}
			</div>
  		)
  	}
}

export default HeaderM




// WEBPACK FOOTER //
// ./src/component/headerM/headerM.js